import { Button, Tabs, TabsProps } from "antd";
import { useEffect } from "react";
import ListAllPlans from "./ListAllPlans";
import {
    IChannel,
    IValueBoolean,
    SubModule,
    TActiveClientId,
    TClientTags,
    TMediaPlanList,
    User,
} from "@/ts/common-types";
import Layout from "@/components/wrappers/layouts/main-layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { updateTitle } from "@/features/titleSlice";
import { updateActiveModule } from "@/features/activeModuleSlice";
import { updateAddMediaPlanModalDisplay } from "@/features/modalSlice";
import CreateOrEditMediaPlan from "./CreateOrEditMediaPlan";
import {
    getActiveModule,
    getClientTagsList,
    listMediaPlans,
    resetMediaPlanningConfig,
    titleCase,
} from "@/ts/utils";
import { updateClientTagsList } from "@/features/clientDataSlice";
import { filter } from "underscore";

const MediaPlanning = () => {
    const dispatch = useDispatch();

    const { activeModule } = getActiveModule();

    const userDetails = useSelector(
        (state: { userData: { value: User } }) => state.userData.value
    );

    const showNewMediaPlanDisplay = useSelector(
        (state: { showNewMediaPlanDisplay: IValueBoolean }) =>
            state.showNewMediaPlanDisplay.value
    );

    const channel = useSelector((state: IChannel) => state.channel.value);
    const activeClientId = useSelector(
        (state: TActiveClientId) => state.activeClientId.value
    );

    const mediaPlanningList = useSelector(
        (state: { mediaPlanningList: { value: TMediaPlanList[] } }) =>
            state.mediaPlanningList.value
    );

    useEffect(() => {
        getClientTagsList()
            .then((tagsList: TClientTags[]) => {
                dispatch(
                    updateClientTagsList(
                        filter(tagsList, (tag) =>
                            ["global", "campaign"].includes(tag.record_type)
                        )
                    )
                );
            })
            .catch((error) => {
                console.error(error);
            });

        listMediaPlans().catch((error) => {
            console.error(error);
        });
    }, [activeClientId, channel, dispatch]);

    useEffect(() => {
        dispatch(updateTitle(titleCase(SubModule.MEDIA_PLANNING)));
        dispatch(updateActiveModule(SubModule.MEDIA_PLANNING));
    }, [dispatch]);

    useEffect(() => {
        // reset planning module once navigated to other modules
        resetMediaPlanningConfig();
    }, [activeModule]);

    const tabItems: TabsProps["items"] = [
        {
            key: "all-plans",
            label: "All",
            children: <ListAllPlans rowData={mediaPlanningList} />,
        },
        {
            key: "my-plans",
            label: "My Plans",
            children: (
                <ListAllPlans
                    rowData={filter(
                        mediaPlanningList,
                        (planData) => planData.user_id === userDetails.uid
                    )}
                />
            ),
        },
    ];

    return (
        <>
            {!showNewMediaPlanDisplay ? (
                <Layout>
                    <div className="plan-list-container">
                        <Tabs
                            size="large"
                            items={tabItems}
                            tabBarExtraContent={
                                <Button
                                    type="primary"
                                    onClick={() =>
                                        dispatch(
                                            updateAddMediaPlanModalDisplay(true)
                                        )
                                    }
                                >
                                    Create New
                                </Button>
                            }
                        />
                    </div>
                </Layout>
            ) : (
                <CreateOrEditMediaPlan />
            )}
        </>
    );
};

export default MediaPlanning;
